import { render, staticRenderFns } from "./Inform.vue?vue&type=template&id=adaa1472&scoped=true&"
import script from "./Inform.vue?vue&type=script&lang=ts&"
export * from "./Inform.vue?vue&type=script&lang=ts&"
import style0 from "./Inform.vue?vue&type=style&index=0&id=adaa1472&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adaa1472",
  null
  
)

export default component.exports